import { AttributionControl } from 'maplibre-gl';

/** Let MapLibre follow active source metadata, without collapsing credits after a drag. */
export function mapAttributionControl(): AttributionControl {
  return new AttributionControl({ compact: false });
}
